<template>
  <b-card class="borde-azul p-0 ">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="hasEmpty"
          style="color: red; text-align: right">
      Tienes padecimientos adicionales "sin definir"
    </div>
    <div v-if="hasDuplicates" style="color: red; text-align: right">
      Tienes padecimientos adicionales "duplicados"
    </div>
    <b-row>
      <b-col md="2" sm="4" class="subcategoria d-flex align-items-center flex--wrap descripcionDiente">
        <img alt="pad" width="29" src="../../../assets/icons/diente-blanco.png">
        <span class="ml-3" v-if="diente.diente.diente.length<= 2"> OD {{ diente.diente.diente }}</span>
        <span v-else class="ml-3">{{ diente.diente.diente }}</span>
      </b-col>
      <b-col md="8" sm="6">
        <v-select id="padecimiento" name="padecimiento" placeholder="Agregar padecimiento"
                  v-model="diente.padecimiento"
                  :disabled="disable"
                  :options="padecimientos"
                  :class="statePadecimiento"
                  label="descripcion"
                  @input="cambioPadecimiento(diente)" />
        <span class="text-small bold" style="font-size: 12px;">  {{
            diente.padecimiento != null && diente.padecimiento.etapa != null ? diente.padecimiento.etapa.descripcion : 'Sin etapa'
          }}</span>



      </b-col>
      <b-col class="text-right">
        <input v-model="diente.seleccionar" style="position: initial" class="form-check-input"
               type="checkbox" value="" id="flexCheckDefault">

        <b-button v-if="diente.visible" class="mostrar" size="sm" variant="link"
                  @click="diente.visible = false"
        >
          <font-awesome-icon :icon="['fas', 'chevron-circle-up']"/>
        </b-button>
        <b-button v-if=" !diente.visible" class="esconder" size="sm" variant="link"
                  @click="diente.visible = true"
        >
          <font-awesome-icon :icon="['fas', 'chevron-circle-down']"/>
        </b-button>


        <b-button v-if="!disable" size="sm" v-b-tooltip.hover title="Eliminar Diente"
                  style="color: red !important;" variant="link"
                  @click="eliminarDiente()">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-col>
    </b-row>
    <b-collapse :visible="diente.visible" :id="'collapse-'+index" class="mt-2 ">
      <b-row class="mt-3" v-if="diente.padecimiento !== null" style="width: 100%">
          <b-col cols="12" style="text-align: right">
            <b-button-group >
              <b-button v-if="descentralizado || ptiCdxForzado" style="font-size: 12px;"
                  :class="{ 'button-dentalia-3-activo' : seccEtapa}" class="button-dentalia-3 mr-4" @click="seccEtapa = true">
                Tratamientos
              </b-button>
              <b-button v-if="descentralizado || ptiCdxForzado" style="font-size: 12px;"
                  :class="{ 'button-dentalia-3-activo' : !seccEtapa}" class="button-dentalia-3"  @click="seccEtapa = false">
                Padecimientos
              </b-button>
            </b-button-group>
          </b-col>

          <b-col cols="12" v-if="seccEtapa">
            <b-col cols="3">
              <label>Etapa padecimiento principal</label>
              <v-select name="etapa" placeholder="Agregar etapa"
                        v-model="diente.padecimiento.etapa"
                        :disabled="disable"
                        @input="cambiarEtapa"
                        :options="etapas"
                        label="descripcion"
              ></v-select>
            </b-col>
          </b-col>
      </b-row>
      <hr>


      <b-col cols="12" v-if="!seccEtapa">
        <b-container fluid>

          <b-row  v-if="!disable && (padecimientosAdicionalesNoReq === undefined
                                    || padecimientosAdicionalesNoReq === null
                                    || padecimientosAdicionalesNoReq.length<5)">
            <b-col cols="10">
              <span>Agregar padecimientos adicionales</span>
            </b-col>
            <b-col cols="2" style="text-align: right">
              <b-button size="md" v-b-tooltip.hover title="Agregar nuevo padecimiento"
                        variant="link" @click="agregarPadecimientoAdicional">
                <font-awesome-icon icon="plus-circle"/>
              </b-button>
            </b-col>
          </b-row>

          <form ref="ads" @submit.prevent="submitf"
                v-if="padecimientosAdicionalesNoReq !== undefined
                              && padecimientosAdicionalesNoReq !== null"
          >
            <b-row v-for="(padadd, idx) in padecimientosAdicionalesNoReq" v-bind:key="diente.diente + '-' + idx">

              <b-col cols="8" style="padding-right: 0px;">
                <v-select placeholder="Selecciona un padecimiento"
                          v-model="padadd.pad"
                          :disabled="disable"
                          :options="padecimientos"
                          :class="statePadecimientoAdicional"
                          label="descripcion"
                          :reduce="(variable) => variable.idPadecimiento"
                          :style="padadd.pad==null? 'border: solid red 1px;': ''"
                          @input="actualizarPadecimientosAdds"
                />
              </b-col>
              <b-col style="padding-left: 0px;">
                <b-button size="md" v-b-tooltip.hover title="Eliminar padecimiento"
                          variant="link" style="color: red !important;"
                          @click="quitarPadecimientoAdicional(idx)"
                          v-if="!disable">
                  <font-awesome-icon icon="times-circle"/>
                </b-button>
              </b-col>
            </b-row>
          </form>

          <span v-if="padecimientosAdicionalesNoReq === undefined
                        || padecimientosAdicionalesNoReq === null
                        || padecimientosAdicionalesNoReq.length ===0">
            Sin padecimientos adicionales
          </span>

        </b-container>
      </b-col>


      <b-row v-if="idEtapa !=null && seccEtapa">
        <b-col class="text-end">
          <b-button size="sm" v-b-tooltip.hover
                    v-b-tooltip.hover.v-light.topright="'Editar etapa tratamiento'"
                    variant="ligth" class="button-circle shadow  text-dentalia"
                    @click="editarEtapa()">
            <font-awesome-icon icon="cog"/>
          </b-button>
        </b-col>
      </b-row>

      <b-row v-if="diente.padecimiento != null && descentralizado && seccEtapa" class="mt-3">
        <b-col v-for="(lista,i) in diente.tratamientos" :key=" diente.diente.diente + 'tx'+i">
          <HDXTratamientos
              @ruta="rutaClinica"
              @limpiar="limpiar"
              @cambiarPaquete="cambiarPaquete"
              :disable="disable"
              :paquetes="paquetes"
              :etapas="etapas"
              :etapa="diente.padecimiento.etapa"
              :editar-e="editarE"
              :tratamientos.sync="lista"
              :cat-tratamientos="catTratamientos"
              :idPadecimiento="idPadecimiento"
              @guardarBitacoraCambios="guardarBitacoraCambios"
              :index="i"></HDXTratamientos>
        </b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
import HDXTratamientos from "@/views/odontograma/detalleDiagnostico/HDXTratamientos";
import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";

export default {
  name: "HDXPadecimientos",
  components: {HDXTratamientos},
  props: {
    statePadecimiento: null,
    statePadecimientoAdicional: null,
    stateValidate: null,
    disable: {
      type: Boolean,
      default: false
    },
    detalle: {
      type: Boolean,
      default: false
    },
    descentralizado: Boolean,
    ptiCdxForzado:  {
      type: Boolean,
      default: false
    },
    diente: {
      required: true,
      default: {
        diente: null,
        padecimiento: {
          idPadecimiento: null,
          descripcion: null,
          etapa: null,
        },
        tratamientos: []
      }
    },
    idDenticion: {
      type: Number,
      required: true,
      default: null
    },
    idTagMotivoCita: {
      type: Number,
      required: true,
      default: null
    },
    idClinica: {
      type: Number,
      required: true,
      default: null
    },
    idPaciente: Number,
    idEmpleado: Number,
    index: null,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      seccEtapa:false,
      paquetes: {
        paquete1: [],
        paquete2: [],
        paquete3: [],
      },
      padecimientos: [],
      padecimientosAdicionalesNoReq: [],
      catTratamientos: [],
      catalogosServicios: new CatalogosService(),
      ptiPrsuntivoServicio: new PtiPresuntivoService(),
      lstPlanTratamiento1: [],
      lstPlanTratamiento2: [],
      lstPlanTratamiento3: [],
      listaDientes: [],
      etapas: [],
      editarE: false,
      esconder: false,
      idEtapa: null,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerTratamientos()
    this.idEtapa = this.$route.params.idEtapa
    this.obtenerPadecimientos()
    this.obtenerEtapas()

    this.seccEtapa = this.descentralizado || this.ptiCdxForzado;
  },
  mounted() {
    if (this.idPadecimiento != null) {
      this.obtenerTratamientosDecentralizada();

      if (this.diente.padecimientosAdicionalesNoReq != undefined && this.diente.padecimientosAdicionalesNoReq != null) {
        this.padecimientosAdicionalesNoReq = this.diente.padecimientosAdicionalesNoReq;
      }
    }
  },
  computed: {
    idPadecimiento() {

      if (this.diente.padecimiento === null) {
        return null
      }

      return this.diente.padecimiento.idPadecimiento;
    },
    hasEmpty() {
      return this.padecimientosAdicionalesNoReq !== undefined
          && this.padecimientosAdicionalesNoReq !== null
          && this.padecimientosAdicionalesNoReq.filter(it=>it.pad==null).length>0;
    },
    hasDuplicates() {
      if (this.hasEmpty) {
        return false;
      }

      const valUnicos = this.padecimientosAdicionalesNoReq.filter(it=>it.pad!=null).map(it => it.pad);
      if (valUnicos.length == 0) {
        return false;
      }

      return (new Set(valUnicos)).size !== this.padecimientosAdicionalesNoReq.length;
    },
  },
  watch: {
    idPadecimiento(newPadecimiento, oldPadecimiento) {
      if (oldPadecimiento !== null && oldPadecimiento !== undefined){
        this.guardarBitacoraCambios(1, oldPadecimiento, null);
      }
      this.obtenerTratamientosDecentralizada();
    },
  },
  methods: {
    guardarBitacoraCambios(tipoMovimiento, idPadecimiento, idTratamiento){
      this.validarcambios();
      if (this.idEtapa === undefined ||  this.idEtapa === null) {

        const datos = {
          idClinica: this.idClinica,
          idPaciente: this.idPaciente,
          idEmpleado: this.idEmpleado,
          idDiente: this.diente.diente.idDiente,
          idTratamiento: idTratamiento,
          idPadecimiento: idPadecimiento,
          tipoMovimiento: tipoMovimiento,

        };

        this.$http.post(this.$api + 'ptipresuntivo/guardarCambiosOg', datos).then(() => {

        })
      }
    },
    editarEtapa() {
      this.editarE = !this.editarE;
    },
    obtenerEtapas() {
      this.$http.get(
          this.$api + "padecimientotagetapa/obteneretapas"
      )
          .then((response) => {
            this.etapas = response.data.data
          })
    },
    obtenerPadecimientos() {
      const params = {
        denticion: this.idDenticion,
        idTagMotivoCita: this.idTagMotivoCita
      }
      this.catalogosServicios.obetenerPadecimientosPorDienteDescentralizados(params).then(
          response => {
            this.padecimientos = response.data
          }
      )
    },
    obtenerTratamientos() {
      const params= {
        idClinica: this.idClinica
      }
      this.ptiPrsuntivoServicio.obtenerTramientosPorClinica(params).then(
          response => {
            this.catTratamientos = response
          }
      )
    },
    obtenerTratamientosDecentralizada() {
      if (this.diente.padecimiento != null && this.diente.buscar === true) {
        //this.diente.tratamientos = []

        const params = {
          idClinica: this.idClinica,
          idPadecimiento: this.diente.padecimiento.idPadecimiento,
          idDiente: this.diente.diente.idDiente,
          denticion: this.idDenticion
        }

        
        this.ptiPrsuntivoServicio.obtenertratamientosPadeciminetosCentralizados(params).then(
          response => {
            const datos = response

              if(this.diente.cambio == false || this.diente.cambio === undefined ){

                if(this.diente.tratamientos.length == 0){

                  this.diente.tratamientos.push(datos.tratamientos1)
                  this.diente.tratamientos.push(datos.tratamientos2)
                  this.diente.tratamientos.push(datos.tratamientos3)
                }else{
                  let trt1 = this.diente.tratamientos[0];
                  let trt2 = this.diente.tratamientos[1];
                  let trt3 = this.diente.tratamientos[2];
                  this.diente.tratamientos = [];
                  if(trt1.length > 0){

                    let mod1 = false;
                    trt1.forEach(element => {
                      if(element.modificado == true || element.modificado == undefined){
                        mod1 = true;
                      }
                    });
                    if(mod1 != true){
                      this.diente.tratamientos.push(datos.tratamientos1)
                    }else{
                      this.diente.tratamientos.push(trt1.length > 0 ? trt1 : [])
                    }
                  }else{
                    this.diente.tratamientos.push([])
                  }
                  if(trt2.length > 0){
                    let mod2 = false;
                    trt2.forEach(element => {
                      if(element.modificado == true || element.modificado == undefined){
                        mod2 = true;
                      }
                    });
                    if(mod2 != true){
                      this.diente.tratamientos.push(datos.tratamientos2)
                    }else{
                      this.diente.tratamientos.push(trt2.length > 0 ? trt2 : [])
                    }
                  }else{
                    this.diente.tratamientos.push([])
                  }
                  if(trt3.length > 0){
                    let mod3 = false;
                    trt3.forEach(element => {
                      if(element.modificado == true || element.modificado == undefined){
                        mod3 = true;
                      }
                    });
                    if(mod3 != true){
                      this.diente.tratamientos.push(datos.tratamientos3)
                    }else{
                      this.diente.tratamientos.push(trt3.length > 0 ? trt3 : [])
                    }
                  }else{
                    this.diente.tratamientos.push([])
                  }
                }
              }else{

                this.diente.tratamientos = [];
                this.diente.tratamientos.push(datos.tratamientos1.length > 0 ? datos.tratamientos1 : [])
                this.diente.tratamientos.push(datos.tratamientos2.length > 0 ? datos.tratamientos2 : [])
                this.diente.tratamientos.push(datos.tratamientos3.length > 0 ? datos.tratamientos3 : [])
              }
            

            this.diente.tratamientos.forEach(t => t.forEach(tx => tx.etapa = this.diente.padecimiento.etapa))

            this.paquetes.paquete1 = JSON.parse(JSON.stringify(datos.tratamientos1));
            this.paquetes.paquete2 = JSON.parse(JSON.stringify(datos.tratamientos2));
            this.paquetes.paquete3 = JSON.parse(JSON.stringify(datos.tratamientos3));

            setTimeout(() => {
              this.rutaClinica();
            }, 500);

          }
        )
        
      } else {
        this.paquetes.paquete1 = this.diente.tratamientos[0]
        this.paquetes.paquete2 = this.diente.tratamientos[1]
        this.paquetes.paquete3 = this.diente.tratamientos[2]
      }
      this.diente.buscar = true;
    },

    validarcambios(){
      let variable = this.diente.cambio;
      this.diente.tratamientos.forEach( t => {
        t.forEach(f => {
          if (f.modificado){
            variable = false;
          }
        })

      })

      this.diente.cambio = variable;
    },

    limpiar(index) {
      this.diente.tratamientos = this.diente.tratamientos.map((l, i) => {
        if (i === index) {
          l = [];
        }
        return l
      })
      this.rutaClinica()
      this.diente.cambio = false; 
    },
    cambiarPaquete(index, paquete) {
      this.diente.tratamientos = this.diente.tratamientos.map((l, i) => {
        if (i === index) {
          l = paquete;
          l.forEach(element => {
            element.modificado = true;
          });
        }
        return l
      })
      this.rutaClinica()
      this.diente.cambio = false;
      this.obtenerTratamientosDecentralizada();
    },
    rutaClinica() {
      this.validarcambios();
      this.$emit("rutaClinica")
    },
    eliminarDiente() {
      if (this.diente != null && this.diente.padecimiento != null && this.diente.padecimiento.idPadecimiento !== null){
        this.guardarBitacoraCambios(2, this.diente.padecimiento.idPadecimiento, null)
      }
      this.$emit('eliminarDiente', this.diente)
    },
    cambiarEtapa(etapa) {

      this.diente.tratamientos.forEach(ts =>
          ts.forEach(tx => tx.etapa = etapa)
      )

    },

    agregarPadecimientoAdicional() {
      if (this.padecimientosAdicionalesNoReq === undefined || this.padecimientosAdicionalesNoReq === null) {
        this.padecimientosAdicionalesNoReq = [{
          "pad": null
        }];
      } else {

        this.padecimientosAdicionalesNoReq.push({
          "pad": null
        });
      }
      this.actualizarPadecimientosAdds();
    },

    submitf(e) {
        e.prevent.default();
    },

    quitarPadecimientoAdicional(idx) {
      this.padecimientosAdicionalesNoReq.splice(idx, 1);
      this.actualizarPadecimientosAdds();
    },

    actualizarPadecimientosAdds() {
      // this.$refs.ads.$el.validate();
      this.$refs.ads.checkValidity();
      this.$emit('actualizarPadsAddNoReq', {
        idDiente: this.diente.diente.idDiente,
        pads: JSON.parse(JSON.stringify(this.padecimientosAdicionalesNoReq))
      });
    },

    cambioPadecimiento(padecimiento){
      padecimiento.cambio = true;
    }
  }
}
</script>

<style scoped>
.esconder[aria-expanded="true"] {
  display: none;
}

.esconder[aria-expanded="false"] {
  display: initial;
}

.mostrar[aria-expanded="true"] {
  display: initial;
}

.mostrar[aria-expanded="false"] {
  display: none;
}

.descripcionDiente {
  margin-right: 1rem;
  border-right: solid 1px #c7c7c7
}

</style>